// @flow
import { fromLonLat, toLonLat } from 'ol/proj';
import canUseDom from './canUseDom';
import degToRad from './degToRad';
import environmentLoader from './environmentLoader';
import radToDeg from './radToDeg';

export const pad = (value: number) => ('0' + value).slice(-2);
export const toSeconds = (milliseconds: number) => milliseconds / 1000;
export const toMilliseconds = (seconds: number) => seconds * 1000;

type Coordinates = [number, number]; // TODO: switch to read only tuple when supported

export const reverseCoordinates = (coordinates: Coordinates): Coordinates => [coordinates[1], coordinates[0]];

export const fromLatLon = (coordinates: Coordinates): Coordinates => {
    return fromLonLat(reverseCoordinates(coordinates));
};

export const toLatLon = (coordinates: Coordinates): Coordinates => {
    return reverseCoordinates(toLonLat(coordinates));
};

export const isValue = (value: any) => Boolean(typeof value !== 'undefined' && value !== null && value !== '');

export {
    canUseDom,
    degToRad,
    environmentLoader,
    radToDeg
};